const style = (theme) => {
  const output = {
    root: {
      minHeight: '100%',
      color: theme.colors[1],
    },
    wrapper: {
      extend: theme.wrapper,
    },
    hoverList: {
      color: theme.colors[0],
      background: theme.colors[1],
      paddingTop: '15vh',
      paddingBottom: '15vh',
    },
    pretitle: {
      fontWeight: 'bold',
      fontSize: 16,
      lineHeight: 1.5,
      textTransform: 'uppercase',
    },
    containerVideo: {
      extend: theme.wrapper,
      background: theme.colors[1],
      paddingTop: '15vh',
      paddingBottom: '15vh',
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    containerVideo: {
      paddingTop: '15vh',
      paddingBottom: '15vh',
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
  }

  return output
}

export default style
